import { ArrowBack } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  DialogContentText,
  Stack,
  Typography,
} from '@mui/material'
import Image from 'next/image'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

export interface Props {
  email: string
  onBackClicked: () => void
}

export const LoginMagicLinkContainer = ({ email, onBackClicked }: Props) => {
  const { t } = useTranslation('login')
  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Stack spacing={0}>
        <Stack direction="row" style={{ paddingTop: 11, paddingBottom: 39 }}>
          <IconButton aria-label="back" onClick={onBackClicked}>
            <ArrowBack />
          </IconButton>
        </Stack>
        <Stack spacing={2} alignItems="center">
          <Image src="/app/assets/email.svg" alt="email sent" height={140} width={215} />
          <Typography style={{ paddingTop: 30 }} suppressHydrationWarning variant="display-h2">
            {t('magic-link.title')}
          </Typography>
          <Trans
            i18nKey="login:magic-link.subtitle"
            components={{
              p: <Typography textAlign="center" variant="body-regular" color="text.muted" />,
              b: <b />,
            }}
            values={{ email }}
          />
          <Link onClick={handleClickOpen}>
            <Typography suppressHydrationWarning variant="body-regular">
              {t('magic-link.link')}
            </Typography>
          </Link>
        </Stack>
      </Stack>
      <Dialog sx={{ zIndex: 9999 }} open={open} onClose={handleClose}>
        <DialogTitle>{t('magic-link.dialog.title')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans
              i18nKey="login:magic-link.dialog.body"
              components={{
                ul: <List sx={{ listStyleType: 'disc', pl: 6 }} />,
                li: (
                  <ListItem
                    sx={{
                      display: 'list-item',
                      padding: '0',
                    }}
                  />
                ),
                lit: (
                  <ListItemText
                    slotProps={{
                      primary: { suppressHydrationWarning: true },
                    }}
                  />
                ),
                b: <b />,
              }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary" variant="contained" suppressHydrationWarning>
            {t('magic-link.dialog.close-button')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
